module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light-Italic.19b5de73.eot";